const sectionReviewTitanCss = `
[data-type='section-review-titan'] [data-attribute='card-container'] {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: var(--text-color, #000000);
}

[data-type='section-review-titan'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-review-titan'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-review-titan'] [data-attribute='card-container'] h1,
[data-type='section-review-titan'] [data-attribute='card-container'] h2,
[data-type='section-review-titan'] [data-attribute='card-container'] h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  line-height: normal;
}

[data-type='section-review-titan'] [data-attribute='card-container'] p {
  font-size: 16px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
}

[data-type='section-review-titan'] .wrap-card {
  position: relative;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-image-container {
  margin-bottom: 20px;
  aspect-ratio: 1/1;
  position: relative;
  overflow: hidden;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-image-container img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content {
  margin-bottom: 18px;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .wrap-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 9px;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .wrap-stars svg {
  display: block;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-content-text {
  font-size: 14px;
  line-height: normal;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-content-text h1,
[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-content-text h2,
[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-content-text h3 {
  font-size: 16px;
  line-height: normal;
  margin-bottom: 10px !important;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-content-text p {
  font-size: 14px;
  color: #6c6e72;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .review-name {
  font-size: 15px;
  font-weight: bold;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .verified-buyer {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #6c6e72;
}

[data-type='section-review-titan'] .wrap-card .body-review .content-item .review-content .verified-buyer svg {
  display: block;
}

[data-type='section-review-titan'] .wrap-card .swiper-button-next,
[data-type='section-review-titan'] .wrap-card .swiper-button-prev {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #000000a1;
}

[data-type='section-review-titan'] .wrap-card .swiper-button-next::after,
[data-type='section-review-titan'] .wrap-card .swiper-button-prev::after {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}

[data-type='section-review-titan'] .wrap-card .swiper-pagination {
  position: relative;
  display: none;
}

[data-type='section-review-titan'] .wrap-card .swiper-pagination .swiper-pagination-bullet {
  width: 20px;
  height: 4px;
  border-radius: 2px;
}

[data-type='section-review-titan'] .wrap-card .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #606f99;
}

@container (max-width: 768px) {
  [data-type='section-review-titan'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-review-titan'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-review-titan'] [data-attribute='card-container'] h1,
  [data-type='section-review-titan'] [data-attribute='card-container'] h2,
  [data-type='section-review-titan'] [data-attribute='card-container'] h3 {
    font-size: 20px;
  }

  [data-type='section-review-titan'] [data-attribute='card-container'] p {
    font-size: 14px;
  }
}

@container (max-width: 640px) {
  [data-type='section-review-titan'] .wrap-card .swiper-button-next,
  [data-type='section-review-titan'] .wrap-card .swiper-button-prev {
    display: none;
  }

  [data-type='section-review-titan'] .wrap-card .swiper-pagination {
    display: block;
  }
}
`;
export default sectionReviewTitanCss;
